<template>
    <AppPage :title="t('message.like')" :show-back="true">
        <AppHeader :show-back="true" :title="t('message.like')" />
        <div class="like-container  h-100vh overflow-y-auto">
            <div class="cards-grid mt-30px" v-if="!loading">
                <AppCard v-for="item in recommendRoles" :key="item.id" :info="item" class="card-item"
                    :isShowTags="false" :isLike="true" />
            </div>
            <div v-else class="mt-30px">
                <SkeletonPresets preset="card" :loading="true" :animated="true" />
            </div>
            <div v-if="recommendRoles.length === 0 && !loading">
                <AppEmpty :imgSrc="likeEmpty" :show-btn="true" />
            </div>
            <!-- <AppOccupySpace height="00px"></AppOccupySpace> -->
        </div>
    </AppPage>
</template>

<script setup lang="ts">
import { AppCard } from '@/components/display'
import { SkeletonPresets } from '@/components/display'
import { AppEmpty } from '@/components/display'
import { AppPage, AppOccupySpace, AppHeader } from '@/components/layout'
import { HomeAPI } from '@/services/home'
import { onMounted } from 'vue'
import { ref } from 'vue'
import likeEmpty from '@/assets/images/message/like_empy.webp'
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
const recommendRoles = ref<any[]>([])
const loading = ref(false)

const getDialogueListFun = async () => {
    try {
        loading.value = true
        const res = await HomeAPI.getDialogueList({ type: 1 })
        recommendRoles.value = res?.data || []
        console.log('recommendRoles', recommendRoles.value)
    } catch (error) {
        console.error('获取对话列表失败:', error)
    } finally {
        loading.value = false
    }
}

onMounted(async () => {
    await getDialogueListFun()
})
</script>

<style scoped lang="scss">
.cards-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
    width: 100%;
}

.card-item {
    width: 100%;
}

.btn {
    width: 210px;
    height: 36px;
    background: linear-gradient(180deg, #5A68FF 0%, #95A5FF 100%);
    border-radius: 20px;
}

.like-container {
    height: calc(100vh - 50px);
}
</style>
